import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DiagStackAvailableOTXSequence } from '@vi-iot/client';

import { DiagStackOtxActions } from './diag-stack-otx.actions';
import {
  DtcVdds,
  OtxBackupConfigurationResponseStructure,
  OtxProcedureFileName,
  OtxProcedureName,
} from './diag-stack-otx.model';
import { DiagStackOtxSelectors } from './diag-stack-otx.selectors';

@Injectable({ providedIn: 'root' })
export class DiagStackOtxStore {
  isOtxAvailableSequencesLoading$: Observable<boolean> = this.store.select(
    DiagStackOtxSelectors.isOtxAvailableOtxSequencesLoading
  );
  isOtxSequenceRunning$: Observable<boolean> = this.store.select(
    DiagStackOtxSelectors.isOtxSequenceRunning
  );

  isOtxVddSequenceLoading$: Observable<boolean> = this.store.select(
    DiagStackOtxSelectors.isOtxVddSequenceLoading
  );

  isAnyOfTheOtxVddSequenceInError$: Observable<boolean> = this.store.select(
    DiagStackOtxSelectors.isAnyOfTheOtxVddSequenceInError
  );

  isAnyFromOtxVddListLoading$: Observable<boolean> = this.store.select(
    DiagStackOtxSelectors.isAnyFromOtxVddListLoading
  );

  diagStackAvailableOtxSequences$: Observable<DiagStackAvailableOTXSequence[]> = this.store.select(
    DiagStackOtxSelectors.getDiagStackAvailableOtxSequences
  );

  getListOfVddFromOtxSequenceResult$: Observable<DtcVdds[]> = this.store.select(
    DiagStackOtxSelectors.getListOfVddFromOtxSequenceResult
  );

  getFlattenedListOfVddFromOtxSequenceResult$: Observable<string[]> = this.store.select(
    DiagStackOtxSelectors.getFlattenedListOfVddFromOtxSequenceResult
  );

  getBackupListOfResultStructures$: Observable<
    OtxBackupConfigurationResponseStructure[]
  > = this.store.select(DiagStackOtxSelectors.getBackupListOfResultStructures);

  executeOtx_GetDTCErrorSettingCondition_Attempt(
    otxProcedureName: OtxProcedureName,
    otxProcedureFileName: OtxProcedureFileName
  ): void {
    this.store.dispatch(
      DiagStackOtxActions.executeOtx_GetDTCErrorSettingCondition.attempt({
        otxProcedureName,
        otxProcedureFileName,
      })
    );
  }

  getAvailableOtxSequencesAttempt(): void {
    this.store.dispatch(DiagStackOtxActions.getAvailableOtxSequences.attempt());
  }

  getAvailableOtxSequencesSequenceMissing(): void {
    this.store.dispatch(DiagStackOtxActions.getAvailableOtxSequences.sequenceMissing());
  }

  triggerOtxVddsReadAgain(): void {
    this.store.dispatch(DiagStackOtxActions.triggerOtxVddsReadAgainAttempt());
  }

  executeOtx_BackupConfiguration_Attempt(): void {
    this.store.dispatch(DiagStackOtxActions.executeOtx_BackupConfiguration.attempt());
  }

  executeOtx_RestoreConfiguration_Attempt(): void {
    this.store.dispatch(DiagStackOtxActions.executeOtx_RestoreConfiguration.attempt());
  }

  executeOtx_BackupConfiguration_AttemptAsync(): void {
    this.store.dispatch(DiagStackOtxActions.executeOtx_BackupConfiguration.attemptAsync());
  }

  executeOtx_RestoreConfiguration_AttemptAsync(): void {
    this.store.dispatch(DiagStackOtxActions.executeOtx_RestoreConfiguration.attemptAsync());
  }

  constructor(private store: Store) {}
}
